import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ApplicationException } from 'src/app/shared/exceptions/application.exception';
import { Organization } from 'src/app/shared/models/organization';
import { Process } from 'src/app/shared/models/process';
import { User } from 'src/app/shared/models/user';
import { TextService } from 'src/app/shared/service/text.service';
import { UsersService } from '../../services/users.service';
import { environment } from 'src/environments/environment';

import { Attachment } from '../../../../shared/models/attachment';
import { SnackbarService } from 'src/app/shared/service/snackbar.service';

@Component({
  selector: 'app-users-banner',
  templateUrl: './users-banner.component.html',
  styleUrls: ['./users-banner.component.scss'],
  providers: [TextService],
})
export class UsersBannerComponent {
  @Output() DownloadButtonClickedEvent: EventEmitter<boolean> =
    new EventEmitter();
  @Input() processList: Process[] = [];
  @Input() isUsersAdminPage = false;
  @Input() isConnectedUserBusinessAdmin: boolean;
  @Input() connectedUserUserType: string;

  userManagementDisabled = environment.userManagementDisabled;
  bannerTitle = '';
  bannerSubtitle = '';
  @Input() isLoading = true;

  attachment: Attachment[] = [];
  files: any = [];
  isFormatAccepted = false;
  attachmentsFormatsEnabled: string;
  attachmentsMaxSizeEnabled: string;

  @Input() subfolder;
  @Input() isUploadingFromUpdatingBox;
  @Output() CancelUploadButtonClickedEvent: EventEmitter<boolean> =
    new EventEmitter();
  @Output() ConfirmUploadButtonClickedEvent: EventEmitter<any> =
    new EventEmitter();

  @ViewChild('fileInput', { static: false }) fileInput: any;

  constructor(
    private usersService: UsersService,
    private dialog: MatDialog,
    private textService: TextService,
    public snackBar: MatSnackBar,
    private snackbar: SnackbarService
  ) { }

  refreshPage(): void {
    window.location.reload();
  }

  openSnackbar(message: string): void {
    const config = new MatSnackBarConfig();
    config.duration = 3000;
    this.snackBar.open(message, undefined, config);
  }

  openSnackbarWithDuration(message: string, duration: number): void {
    const config = new MatSnackBarConfig();
    config.duration = duration;
    this.snackBar.open(message, undefined, config);
  }
}
